import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from "@sentry/react";
import App from './app/app';

if (process.env.NX_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.NX_PUBLIC_SENTRY_DSN,
    debug: process.env.NODE_ENV === 'development',
    environment: process.env.NX_PUBLIC_ENV || process.env.NODE_ENV,
    release: process.env.NX_PUBLIC_VERSION
  });
};

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <StrictMode>
    <Sentry.ErrorBoundary>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
